import React, { useEffect } from "react";
import "./BookingConfirmationModal.css";

const BookingConfirmationModal = ({ status, title, message, summary, onClose }) => {
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [onClose]);

  if (!status) return null;

  return (
    <div className="booking-modal-backdrop" onClick={onClose}>
      <div
        className={`booking-modal booking-modal--${status}`}
        role="dialog"
        aria-modal="true"
        aria-labelledby="booking-modal-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="booking-modal-icon">{status === "success" ? "✓" : "!"}</div>
        <h3 id="booking-modal-title">{title}</h3>
        <p className="booking-modal-message">{message}</p>

        {summary && (
          <div className="booking-modal-summary">
            {summary.map((line) => (
              <div className="booking-modal-summary-row" key={line.label}>
                <span>{line.label}</span>
                <strong>{line.value}</strong>
              </div>
            ))}
          </div>
        )}

        <button type="button" className="booking-modal-close" onClick={onClose}>
          Got it
        </button>
      </div>
    </div>
  );
};

export default BookingConfirmationModal;
